import React from 'react'
import logo from './img/logo.png'
import uuid from 'uuid/v1'
import {
  Link
} from 'react-router-dom'


const NavBar = ({pathName}) => {

  const links = pathName === '/contacto' ? [{ name: 'Home', href: '/' }] : [{ name: 'Servicios', href: '#services-link', subLinks: [{ name: 'Exportación', href: '#export-link' }, { name: 'Importación', href: '#import-link' }, { name: 'Especial', href: '#special-link' }] }, 
  { name: 'A cerca de', href: '#about-link' },
  { name: 'Clientes', href: '#clients-link' },
  // { name: 'Links', href: '#links-link' },
  { name: 'Contacto', href: '/contacto' }]

  const generateLink = (config) => (
    <li  key={uuid()}><a href={config.href}>{config.name}</a>
        { config.subLinks &&  <ul>
            {
              config.subLinks.map(x => (<li key={uuid()}><a href={x.href}>{x.name}</a></li>))
            }
        </ul> }
    </li>
  )

  return (
  
  
    <header className="top-area" style={{ height: 0 }}>

    <div className="header-top-area">
    
    <div className="mainmenu-area" id="mainmenu-area">
  <div className="mainmenu-area-bg"></div>
  <nav className="navbar">
      <div className="container">
          <div className="navbar-header">
              <Link to={"/"} className="navbar-brand">
                <img style={{height: 50, paddingBottom: 10 }} src={logo} alt="logo" />
              </Link>
          </div>
          <div id="main-nav" className="stellarnav">
              <ul id="nav" className="nav navbar-nav">
                  {
                    links.map(x =>  <li key={uuid()}> { x.href.startsWith('#') ? generateLink(x) : <Link to={x.href}>{x.name}</Link> } 
                    </li>)
                  }
              </ul>
          </div>
      </div>
  </nav>
  </div>
    
      </div>
    
    </header>
  
  
  )
}

export default NavBar